(function () {
  const STORAGE_KEY = 'wp-age-verified';
  const gate = document.getElementById('wp-age-gate');
  if (!gate) return;

  // Already verified — gate stays hidden (is-hidden set in HTML by default)
  if (sessionStorage.getItem(STORAGE_KEY) === '1') return;

  // Not verified — reveal gate and lock scroll
  gate.classList.remove('is-hidden');
  document.body.style.overflow = 'hidden';

  gate.querySelector('#wp-age-yes')?.addEventListener('click', () => {
    sessionStorage.setItem(STORAGE_KEY, '1');
    gate.style.opacity = '0';
    gate.style.transition = 'opacity 400ms ease';
    setTimeout(() => {
      gate.classList.add('is-hidden');
      document.body.style.overflow = '';
    }, 400);
  });

  gate.querySelector('#wp-age-no')?.addEventListener('click', () => {
    window.location.href = 'https://www.google.com';
  });
})();
